import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import useSelectedPatient from '../useSelectedPatient';

export default function usePatientDoses() {
    const patient = useSelectedPatient();
    const currendDose = useRecoilValue(currentDoseState);
    const [availableDoses, setAvailableDoses] = useState<DoseMatrix[]>([]);

    useEffect(() => {
        if (patient) {
            const sets = Array.from(patient.doses).filter(
                (img) => img.dicomUid !== currendDose?.dicomUid
            );
            setAvailableDoses(sets);
        }
    }, [patient, currendDose]);

    return availableDoses;
}
